import React from 'react';

class ProjectDetails extends React.Component {
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50">
                    <div className="container">
                        <div className="row d-flex justify-content-center flex-wrap">
                            <div className="col-lg-4 col-md-12 m-b30">
                                <div className="project-detail-left bg-gray p-a30">
                                    <div className="wt-icon-box-wraper left  m-b15 p-b15 bdr-1 bdr-bottom bdr-gray">
                                        <div className="icon-sm m-b15">
                                            <span className="icon-cell  site-text-primary"><i className="fa fa-tachometer" /></span>
                                        </div>
                                        <div className="icon-content">
                                            <h3 className="wt-tilte m-b5">Project</h3>
                                            <p>Refinery Industrial</p>
                                        </div>
                                    </div>
                                    <div className="wt-icon-box-wraper left m-b15 p-b15 bdr-1 bdr-bottom bdr-gray">
                                        <div className="icon-sm m-b15">
                                            <span className="icon-cell  site-text-primary"><i className="fa fa-list-alt" /></span>
                                        </div>
                                        <div className="icon-content">
                                            <h3 className="wt-tilte m-b5">Categories</h3>
                                            <p>Business, Industrial</p>
                                        </div>
                                    </div>
                                    <div className="wt-icon-box-wraper left  m-b15 p-b15 bdr-1 bdr-bottom bdr-gray">
                                        <div className="icon-sm m-b15">
                                            <span className="icon-cell  site-text-primary"><i className="fa fa-calendar" /></span>
                                        </div>
                                        <div className="icon-content">
                                            <h3 className="wt-tilte m-b5">Time</h3>
                                            <p>2 Month</p>
                                        </div>
                                    </div>
                                    <div className="wt-icon-box-wraper left m-b15 p-b15 bdr-1 bdr-bottom bdr-gray">
                                        <div className="icon-sm m-b15">
                                            <span className="icon-cell  site-text-primary"><i className="fa fa-tags" /></span>
                                        </div>
                                        <div className="icon-content">
                                            <h3 className="wt-tilte m-b5">Status</h3>
                                            <p>Good</p>
                                        </div>
                                    </div>
                                    <div className="wt-icon-box-wraper left">
                                        <div className="icon-sm m-b15">
                                            <span className="icon-cell  site-text-primary"><i className="fa fa-user" /></span>
                                        </div>
                                        <div className="icon-content">
                                            <h3 className="wt-tilte m-b5">Client</h3>
                                            <p>Matthew Stone </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-12 m-b30">
                                <div className="project-detail-right">
                                    <h2 className="m-t0">Chemical Refinery Information</h2>
                                    <p>All this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, builder of human happiness. Great explorer of the truth, the master-builder of human happinessbut because those who do not to pursue seds.</p>
                                    <h3 className="m-t0">Successful Complete project </h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse viverra mauris eget tortor imperdiet vehicula. Proin egestas diam ac mauris molestie hendrerit.</p>
                                    <ul className="list-check-circle primary">
                                        <li>Words is roughly being maintained.</li>
                                        <li>Previous casing is maintained.</li>
                                        <li>Letters or begins with a capital letter.</li>
                                    </ul>
                                    <h3 className="m-t0">Problem</h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse viverra mauris eget tortor imperdiet vehicula. Proin egestas diam ac mauris molestie hendrerit.</p>
                                    <h3 className="m-t0">Solution</h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse viverra mauris eget tortor imperdiet vehicula. Proin egestas diam ac mauris molestie hendrerit.</p>
                                    <h3 className="m-t0">Process</h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse viverra mauris eget tortor imperdiet vehicula. Proin egestas diam ac mauris molestie hendrerit.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default ProjectDetails;